<template>
  <div>
    <div style="display: flex;">
      <v-btn
        color="#4d48f9"
        style="
          text-transform: none !important;
          color: white;
          margin-right: 30px;
        "
        @click="routeBannerAdd()"
      >
        YENİ BANNER EKLE
      </v-btn>
    </div>

    <h2 style="margin-top: 30px; margin-bottom: 10px; font-weight: 500;">
      Afişler
    </h2>
    <v-container style="margin-left: 0;">
      <template>
        <v-row style="margin-bottom: 24px;">
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Ara"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row style="margin-top: 12px;">
          <v-col cols="12" md="3" sm="3" style="margin-top: -24px;">
            <h4>Aktiflik/Pasiflik</h4>
            <v-select
              v-model="pageOptions.isActive"
              @change="filterByBannerStatus"
              :items="statusFilterItems"
              item-text="name"
              item-value="value"
              data-vv-name="select"
              required
            ></v-select>
          </v-col>
           <v-col cols="12" md="3" sm="3" style="margin-top: -24px;">
            <h4>Uygulama Türü</h4>
            <v-select
              v-model="pageOptions.applicationType"
              @change="filterByApplicationType"
              :items="applicationTypes"
              item-text="name"
              item-value="value"
              data-vv-name="select"
              required
            ></v-select>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="date"
                  :label="'Başlangıç tarihi'"
                  style="font-weight: bold;"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                :max="new Date().toISOString().substr(0, 10)"
                @change="filterByDateChange(date, endDate)"
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-menu
              v-model="menu3"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="endDate"
                  :label="'Bitiş tarihi'"
                  style="font-weight: bold;"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="endDate"
                :min="nowDate"
                :disabled="datePickerDisable"
                :max="
                  new Date(
                    new Date().getFullYear() + 1,
                    new Date().getMonth(),
                    new Date().getDate(),
                  )
                    .toISOString()
                    .substr(0, 10)
                "
                @change="filterByDateChange(date, endDate)"
                @input="menu3 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-row cols="12" md="4">
            <v-icon
              style="font-size: 17px;"
              v-if="!alertPriority"
              color="#4d48f9"
              @click="alertPriority = !alertPriority"
            >
              info
            </v-icon>

            <v-alert
              v-model="alertPriority"
              border="left"
              close-text="Close Alert"
              color="#4d48f9"
              dark
              dismissible
            >
              Son Kullanma Tarihi seçilen başlangıç ve bitiş tarihi arasında
              olan afişleri filtreler.
            </v-alert>
          </v-row>
        </v-row>

        <v-card>
          <v-data-table
            style="margin-top: 30px;"
            :loading="loading"
            :headers="headers"
            :items="bannerList"
            :footer-props="{
              'items-per-page-options': [10, 25, 50, 100],
              disablePagination: true,
            }"
            :items-per-page="10"
            @update:page="getPageNumber"
            @update:items-per-page="getItemPerPage"
          >
          <template v-slot:item.endDate="{ item }">
              {{ item.endDate ? formatDate(item.endDate) : item.endDate}}
            </template>
            <template v-slot:item.isActive="{ item }">
              {{ item.isActive ? 'Aktif' : 'Pasif' }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="routeBannerEdit(item)">
                mdi-pencil
              </v-icon>
            </template>

            <!-- <template v-slot:item.endDate="{ item }">
              <div class="tooltip-container">
                <v-tooltip v-if="tooltipMessage(item).message" bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      :style="{ color: tooltipMessage(item).color }"
                      v-on="on"
                    >
                      {{ tooltipMessage(item).icon }}
                    </v-icon>
                  </template>
                  <span>{{ tooltipMessage(item).message }}</span>
                </v-tooltip>
              </div>
            </template> -->
          </v-data-table>
          <div class="text-xs-center pt-2">
            <v-pagination
              v-model="pageOptions.pageNumber"
              color="#4d48f9"
              :length="pagination.pagesLength"
              @input="setPageNumber"
            ></v-pagination>
          </div>
        </v-card>
      </template>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
export default {
  name: 'Banners',
  data: () => ({
    search: '',
    searchGroup: '',
    showToolTip: false,
    showToolTipGroup: false,

    statusFilterItems: [
      {
        name: 'Hepsi',
        value: null,
      },
      {
        name: 'Aktif',
        value: true,
      },
      {
        name: 'Pasif',
        value: false,
      },
    ],
    pageOptions: {
      pageNumber: 1,
      pageSize: 10,
      search: '',
      startDate: null,
      endDate: null,
      isActive: null,
      applicationType: null

    },
    pagination: {
      totalItems: 20,
      pagesLength: 0,
    },
    alertPriority: false,
    nowDate: '',
    datePickerDisable: true,
    date: new Date().toISOString().substr(0, 10),
    endDate: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,
    menu3: false,
    headers: [
      { text: 'Banner ID', value: 'id', align: 'start', sortable: false },
      { text: 'Banner Başlık', value: 'title', sortable: false },
      { text: 'Son Kullanım Tarihi', value: 'endDate', sortable: false },
      { text: 'Aktif/Pasif', value: 'isActive', sortable: false },
      { text: 'Sıralama', value: 'order', sortable: false },
      { text: 'Detay', value: 'actions', sortable: false },
    ],
    applicationTypes: [
      {
        name: 'Hepsi',
        value: null
      },
      {
        name: 'UserApp',
        value: 'UserApp',
      },
      {
        name: 'MerchantApp',
        value: 'MerchantApp',
      },
    ],
  }),
  computed: {
    ...mapGetters('banner', ['bannerList', 'loading']),
  },
  created() {
    const page = this.$route.query.page ? Number(this.$route.query.page) : 1

    this.pageOptions.pageNumber = page

    this.getBanners(this.pageOptions).then((response) => {
      this.pagination.totalItems = response.totalCount
      this.pagination.pagesLength = response.totalPages
    })
  },
  methods: {
    ...mapActions('banner', ['getBanners']),
    tooltipMessage(item) {
      const endDate = new Date(item.endDate)
      const today = new Date()
      const oneWeekFromNow = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000)
      if (endDate < today) {
        return {
          message: 'Bu afiş süresi sona erdi',
          icon: 'mdi-exclamation',
          color: 'crimson',
        }
      } else if (endDate <= oneWeekFromNow) {
        return {
          message: 'Bu afiş yakında sonlanacaktır',
          icon: 'mdi-timelapse',
          color: '#FFCD3F',
        }
      }
      return { message: '', icon: '' }
    },
    //Data table item per page changed function
    getItemPerPage(val) {
      console.log('getItemPerPage')
      this.pageOptions.pageSize = val
      this.pageOptions.pageNumber = 1
      this.pagination.pagesLength = Math.ceil(
        this.pagination.totalItems / this.pageOptions.pageSize,
      )
      this.getBanners(this.pageOptions)
    },

    getPageNumber(val) {
      this.pageOptions.pageNumber = val
      this.getBanners(this.pageOptions)
    },
    setPageNumber(val) {
      if (
        (!this.$route.query.page && val == 1) ||
        this.$route.query.page == val
      )
        return
      this.$router.push({ path: this.$route.fullPath, query: { page: val } })
    },
    filterByBannerStatus(value) {
      this.pageOptions.isActive = value
      this.pageOptions.pageNumber = 1
      this.getBanners(this.pageOptions).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
    filterByApplicationType(value) {
      this.pageOptions.applicationType = value
      this.pageOptions.pageNumber = 1
      this.getBanners(this.pageOptions).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
    routeBannerAdd() {
      this.$router.push('/dashboard/banner/new')
    },
    getItemPerSearch(val) {
      this.pageOptions.pageNumber = 1
      this.pageOptions.search = val
      this.getBanners(this.pageOptions).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },

    routeBannerEdit(item) {
      this.$router.push(`/dashboard/banner/list/${item.id}`)
    },
    redirectLink(endpoint) {
      console.log(endpoint)
      window.open(
        endpoint,
        '_blank', // <- This is what makes it open in a new window.
      )
    },

    filterByDateChange(startDate, endDate) {
      startDate = startDate.split(/[- :]/)
      this.pageOptions.startDate =
        startDate[2] + '/' + startDate[1] + '/' + startDate[0]

      endDate = endDate.split(/[- :]/)
      this.pageOptions.endDate =
        endDate[2] + '/' + endDate[1] + '/' + endDate[0]

      this.pageOptions.pageNumber = 1
      this.getBanners(this.pageOptions).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
    formatDate(date){
      return moment(date).format('DD-MM-yyyy HH:mm')
    }
  },

  watch: {
    date: function () {
      this.nowDate = this.date
      this.datePickerDisable = false
    },
    search: function (val, oldVal) {
      if (val.length < 2 && oldVal.length < 1) return
      this.getItemPerSearch(val)
    },
    searchGroup: function (val, oldVal) {
      if (val.length < 2 && oldVal.length < 1) return
      this.getGroupItemPerSearch(val)
    },
    '$route.query.page'(val) {
      const pageNumber = val ? Number(val) : 1
      this.getPageNumber(pageNumber)
    },
    '$route.query.groupPage'(val) {
      const pageNumber = val ? Number(val) : 1
      this.getPageNumberGroup(pageNumber)
    },
  },
}
</script>

<style scoped>
.tooltip-container {
  display: flex;
}
</style>
